var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99741 4.66406H4.85547",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.202 4.66406H12.0601",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_2235",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 22,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2H22V24H0V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_2235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 4.66406H1.80469C1.0453 4.66406 0.429688 5.27967 0.429688 6.03906V22.1953C0.429688 22.9547 1.0453 23.5703 1.80469 23.5703H20.1953C20.9547 23.5703 21.5703 22.9547 21.5703 22.1953V6.03906C21.5703 5.27967 20.9547 4.66406 20.1953 4.66406H19.3359",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62891 9.82031L21.5701 9.82031",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.429688 9.82031H9.06641",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12484 6.56177C3.8717 6.56177 3.6665 6.11141 3.6665 5.55582V2.98438C3.6665 2.42879 3.8717 1.97843 4.12484 1.97843C4.37798 1.97843 4.58317 2.42879 4.58317 2.98438V5.55582C4.58317 6.11141 4.37798 6.56177 4.12484 6.56177Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8748 6.56177C17.6217 6.56177 17.4165 6.11141 17.4165 5.55582V2.98438C17.4165 2.42879 17.6217 1.97843 17.8748 1.97843C18.128 1.97843 18.3332 2.42879 18.3332 2.98438V5.55582C18.3332 6.11141 18.128 6.56177 17.8748 6.56177Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 6.56177C11.2052 6.56177 11 6.11141 11 5.55582V2.98438C11 2.42879 11.2052 1.97843 11.4583 1.97843C11.7115 1.97843 11.9167 2.42879 11.9167 2.98438V5.55582C11.9167 6.11141 11.7115 6.56177 11.4583 6.56177Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5011 12.4494L12.338 14.1451L14.2093 14.417C14.6659 14.4834 14.8482 15.0445 14.5178 15.3665L13.1637 16.6864L13.4834 18.5501C13.5614 19.0049 13.0841 19.3517 12.6757 19.137L11.002 18.257L9.32821 19.137C8.91983 19.3517 8.44254 19.0049 8.52052 18.5501L8.84017 16.6864L7.48609 15.3665C7.15571 15.0445 7.33802 14.4834 7.79461 14.417L9.6659 14.1451L10.5028 12.4494C10.7069 12.0357 11.297 12.0357 11.5011 12.4494Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterCalendar);
export default __webpack_public_path__ + "static/media/footerCalendar.a9ea47c35a26335e6570216c1fc23ca4.svg";
export { ForwardRef as ReactComponent };